import { render } from "./atcs-impersonate.html?vue&type=template&id=4d14ab5e&scoped=true&ts=true&external"
import script from "./atcs-impersonate.ts?vue&type=script&lang=ts&external"
export * from "./atcs-impersonate.ts?vue&type=script&lang=ts&external"

import "./atcs-impersonate.scss?vue&type=style&index=0&id=4d14ab5e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d14ab5e"]])

export default __exports__